import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  videoMasterDetail: {},
  cartSize: {},
  courseDetail: {},
  cartList: [],
  mikroVideosList: [],
  miniVideosList: [],
  masterVideosList: [],
  sliderList: [],
  categoryVideos: [],
  videosList: [],
  reelsList: [],
  searchChannelsList: [],
  videoAnalytics: [],
  videoPublicAnalytics: [],
  searchVideosList: [],
  bookmarkList: [],
  videoDetail: {},
  receiptDetail: [],
  subscriptionList: [],
  statisticBookmarkLike: [],
  statisticCountLike: [],
  statisticCountBookmark: [],
  totalRevenue: [],
  totalSales: [],
  montlyRevenue: [],
  montlySales: [],
  montlySalesDetail: [],
  totalSalesDetail: [],
  deviceList: [],
  categorySearchVideosList: [],
  pageContent: [],
  bestLike: [],
  bestBookmark: [],
  subscriptionEarnings: [],
  subscriptionAnalyticsProfile: null,
  subscriptionAnalyticsProfileLoading: false,
  mySubscription: null,
  myPayments: [],
  bestPlays: null,
  loading: false,
  error: undefined,
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchSliderList(state, action) {
      state.sliderList = action.payload;
      state.loading = false;
    },
    fetchClearSliderList(state, action) {
      state.sliderList = [];
      state.loading = false;
    },
    fetchVideosList(state, action) {
      state.videosList = action.payload;
      state.loading = false;
    },
    fetchReelsList(state, action) {
      state.reelsList = action.payload;
      state.loading = false;
    },
    fetchClearReelsList(state, action) {
      state.reelsList = [];
      state.loading = false;
    },
    fetchVideosListMicro(state, action) {
      state.mikroVideosList = action.payload;
      state.loading = false;
    },
    fetchVideosListMini(state, action) {
      state.miniVideosList = action.payload;
      state.loading = false;
    },
    fetchVideosListMaster(state, action) {
      state.masterVideosList = action.payload;
      state.loading = false;
    },
    fetchSearchVideosList(state, action) {
      state.searchVideosList = action.payload;
      state.loading = false;
    },
    fetchSearchChannelsList(state, action) {
      state.searchChannelsList = action.payload;
      state.loading = false;
    },
    fetchCartList(state, action) {
      state.cartList = action.payload;
      state.loading = false;
    },
    fetchCategoryVideosList(state, action) {
      state.categoryVideos = action.payload;
      state.loading = false;
    },
    fetchCartSize(state, action) {
      state.cartSize = action.payload;
      state.loading = false;
    },
    fetchVideoDetail(state, action) {
      state.videoDetail = action.payload;
      state.loading = false;
    },
    fetchCourseDetail(state, action) {
      state.courseDetail = action.payload;
      state.loading = false;
    },
    fetchClearCourseDetail(state, action) {
      state.courseDetail = {};
      state.loading = false;
    },
    fetchVideoMasterDetail(state, action) {
      state.videoMasterDetail = action.payload;
      state.loading = false;
    },
    fetchClearVideoMasterDetail(state, action) {
      state.videoMasterDetail = {};
      state.loading = false;
    },
    fetchBookmarkList(state, action) {
      state.bookmarkList = action.payload;
      state.loading = false;
    },
    fetchVideoAnalytics(state, action) {
      state.videoAnalytics = action.payload;
      state.loading = false;
    },
    fetchVideoAnalyticsPublic(state, action) {
      state.videoPublicAnalytics = action.payload;
      state.loading = false;
    },
    fetchReceiptList(state, action) {
      state.receiptList = action.payload;
      state.loading = false;
    },
    fetchReceiptDetail(state, action) {
      state.receiptDetail = action.payload;
      state.loading = false;
    },
    fetchSubscriptionList(state, action) {
      state.subscriptionList = action.payload;
      state.loading = false;
    },
    fetchStatisticBookmarkLike(state, action) {
      state.statisticBookmarkLike = action.payload;
      state.loading = false;
    },
    fetchStatisticCountLike(state, action) {
      state.statisticCountLike = action.payload;
      state.loading = false;
    },
    fetchStatisticCountBookmark(state, action) {
      state.statisticCountBookmark = action.payload;
      state.loading = false;
    },
    fetchTotalSales(state, action) {
      state.totalSales = action.payload;
      state.loading = false;
    },
    fetchTotalRevenue(state, action) {
      state.totalRevenue = action.payload;
      state.loading = false;
    },
    fetchMontlyRevenue(state, action) {
      state.montlyRevenue = action.payload;
      state.loading = false;
    },
    fetchMontlySales(state, action) {
      state.montlySales = action.payload;
      state.loading = false;
    },
    fetchMontlySalesDetail(state, action) {
      state.montlySalesDetail = action.payload;
      state.loading = false;
    },
    fetchTotalSalesDetail(state, action) {
      state.totalSalesDetail = action.payload;
      state.loading = false;
    },
    fetchDeviceList(state, action) {
      state.deviceList = action.payload;
      state.loading = false;
    },
    fetchCategorySearchVideosList(state, action) {
      state.categorySearchVideosList = action.payload;
      state.loading = false;
    },
    fetchBestLike(state, action) {
      state.bestLike = action.payload;
      state.loading = false;
    },
    fetchBestBookmark(state, action) {
      state.bestBookmark = action.payload;
      state.loading = false;
    },
    fetchPageContent(state, action) {
      state.pageContent = action.payload;
      state.loading = false;
    },
    fetchSubscriptionEarnings(state, action) {
      state.subscriptionEarnings = action.payload;
      state.loading = false;
    },
    fetchSubscriptionAnalyticsProfile(state, action) {
      state.subscriptionAnalyticsProfile = action.payload;
      state.subscriptionAnalyticsProfileLoading = false;
      state.loading = false;
    },
    fetchSubscriptionAnalyticsProfileStart(state) {
      state.subscriptionAnalyticsProfileLoading = true;
    },
    fetchSubscriptionAnalyticsProfileFailure(state) {
      state.subscriptionAnalyticsProfileLoading = false;
    },
    fetchMySubscription(state, action) {
      state.mySubscription = action.payload;
      state.loading = false;
    },
    clearMySubscription(state) {
      state.mySubscription = null;
    },
    fetchMyPayments(state, action) {
      state.myPayments = action.payload;
      state.loading = false;
    },
    fetchBestPlays(state, action) {
      state.bestPlays = action.payload;
      state.loading = false;
    },
  },
});

export const globalActions = globalSlice.actions;

export default globalSlice.reducer;
